module.exports = __webpack_public_path__ + "img/closed-loop-12.a7f8bed8.png";